import getI18nByKey from '@/common/js/getI18nByKey';
/**
 * 首页模块（标签）类型 tagType为０的都是app上自定义的,web上就不展示了
 */
export const tagTypes = {
  messages: {
    componentName: 'message-card', //消息
    value: 10,
  },
  myModules: {
    componentName: 'my-card', //常用模块
    value: 11,
  },
  todoList: {
    componentName: 'todo-list-card', //待办单
    value: 5,
  },
  customFlow: {
    componentName: 'custom-flow-card', //客流数
    value: 7,
  },
  customTops: {
    componentName: 'custom-tops-card', //客流排行
    value: 9,
  },
  deviceStatus: {
    componentName: 'device-status-card', //设备概况
    value: 8,
  },
  favorite: {
    componentName: 'video-list-card', //我收藏的
    value: 1,
  },
  lastestVideo: {
    componentName: 'video-list-card', //最近观看
    value: 2,
  },
  loginStatus: {
    componentName: 'login-status-card', //登录情况
    value: 6,
  },
  taskStatus: {
    componentName: 'task-status-card', //任务信息
    value: 12,
  },
  dataCenter: {
    componentName: 'data-center-card', //数据中心
    value: 13,
  },
  inspectionStatus: {
    componentName: 'inspection-status', // 巡店概况
    value: 20,
  },
  scoreSort: {
    componentName: 'score-sort', // 巡店排名
    value: 21,
  },
  unqualifiedItem: {
    componentName: 'unqualified-item', // 不合格点检项
    value: 22,
  },
  problemProcessingSpeed: {
    componentName: 'problem-processing-speed', // 问题处理进度
    value: 23,
  },
  distributionChartInspection: {
    componentName: 'distribution-chart-inspection', // 巡店时间分布
    value: 24,
  },
  boardCard: {
    componentName: 'board-card', // 巡店时间分布
    value: 15,
  },
  storeSecretVisitRanking: {
    componentName: 'store-secret-visit-ranking', // 门店暗访得分排行
    value: 26,
  },
  scoreDistributionSecretItems: {
    componentName: 'score-distribution-secret-items', //暗访检查项得分分布
    value: 27,
  },
  scoreRateSecretItems: {
    componentName: 'score-rate-secret-items', //暗访检查项得分率
    value: 28,
  },
  taskOverview: {
    componentName: 'task-overview', //任务总览
    value: 29,
  },
  examineApprove: {
    componentName: 'examine-approve', //审批
    value: 30,
  },
  goldList: {
    componentName: 'gold-list', //金币排行
    value: 25,
  },
  trainingOverview: {
    componentName: 'training-overview', //培训概览
    value: 106,
  },
  learningTime: {
    componentName: 'learning-time', //学习时长TOP100
    value: 107,
  },
  aiCheck: {
    componentName: 'ai-check', // AI检测 问题图片
    value: 32,
  },
  userDefinedType: {
    componentName: '', //用户自定义的
    value: 0,
  },
  accurateFlow: {
    componentName: 'accurate-flow', //精准客流
    value: 34,
  },
  hotFlow: {
    componentName: 'hot-flow', //热力图
    value: 33,
  },
  storeType: {
    componentName: 'store-type', //门店类型
    value: 1001,
  },
  customFlowAverageCard: {
    componentName: 'custom-flow-average-card', //进店客流日均值
    value: 1002,
  },
};
//计算规则
export const numberUnitRules = [
  [4, getI18nByKey('common.wplus')],
  [6, getI18nByKey('common.bwplus')],
]; //超过４位数显示万+，超过６位数显示百万+

//定义数字相关的
export const NUMBER_GLOBAL = {
  taskNumber: 3, //今日待办任务显示的个数(3)
};

export const hiddenTagTypes = {
  'zh-CN': [],
  'en-US': [],
  'zh-TW': [],
  'id-ID': [],
};
